var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14V5C18 3.895 17.105 3 16 3H14L12.487 0.484C12.306 0.184 11.981 0 11.63 0H6.326C5.97 0 5.641 0.189 5.462 0.496L4 3H2C0.895 3 0 3.895 0 5V14C0 15.105 0.895 16 2 16H16C17.105 16 18 15.105 18 14ZM11.8795 11.8062C13.4365 10.2492 13.4365 7.72478 11.8795 6.16777C10.3225 4.61074 7.79803 4.61074 6.24101 6.16777C4.68399 7.72478 4.68399 10.2492 6.24101 11.8062C7.79803 13.3633 10.3225 13.3633 11.8795 11.8062Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.434ebdad3ea43cf044831e1b93b7211c.svg";
export { ForwardRef as ReactComponent };